import { Note, LegacyDataTable, LegacyDataTableBody, LegacyDataTableHeader, LegacyDataTableHeaderColumn, LegacyDataTableRow, LegacyDataTableRowColumn } from "@octopusdeploy/design-system-components";
import cn from "classnames";
import { GitRefLink } from "~/areas/projects/components/Releases/GitRefLink/GitRefLink";
import { FilesList } from "~/areas/projects/components/Releases/GitResources/FilesList";
import { getCommitLink } from "~/areas/projects/components/Releases/gitHostLinkGenerator";
import type { GitReferenceModel } from "~/areas/projects/components/Releases/gitResourceModel";
import { GitResourcePathContextualHelp, GitResourceReleaseGitReferenceContextualHelp } from "~/components/ContextualHelp/ContextualHelpSnippets";
import type { DataBaseComponentState } from "~/components/DataBaseComponent/index";
import DataBaseComponent from "~/components/DataBaseComponent/index";
import Section from "~/components/Section";
import { withTheme } from "~/components/Theme/index";
import styles from "./Edit/style.module.less";
interface GitResourcesListProps {
    gitReferences: GitReferenceModel[];
}
export class GitResourcesList extends DataBaseComponent<GitResourcesListProps, DataBaseComponentState> {
    constructor(props: GitResourcesListProps) {
        super(props);
        this.state = {};
    }
    render() {
        const showFilePaths = this.props.gitReferences.some((g) => g.FilePathFilters.length > 0);
        return withTheme((theme) => (<div>
                {this.props.gitReferences && this.props.gitReferences.length > 0 ? (<LegacyDataTable className={styles.packageTable}>
                        <LegacyDataTableHeader>
                            <LegacyDataTableRow>
                                <LegacyDataTableHeaderColumn>
                                    <div className={styles.actionName}>Step Repository</div>
                                </LegacyDataTableHeaderColumn>
                                {showFilePaths && (<LegacyDataTableHeaderColumn>
                                        Paths <GitResourcePathContextualHelp />
                                    </LegacyDataTableHeaderColumn>)}
                                <LegacyDataTableHeaderColumn>
                                    Git Reference <GitResourceReleaseGitReferenceContextualHelp />
                                </LegacyDataTableHeaderColumn>
                            </LegacyDataTableRow>
                        </LegacyDataTableHeader>
                        <LegacyDataTableBody>
                            {this.props.gitReferences.map((r, ix) => (<LegacyDataTableRow key={r.ActionName + ix}>
                                    <LegacyDataTableRowColumn key={r.ActionName + ix} className={cn(styles.repositoryColumn, styles.repositoryColumn)}>
                                        <div className={styles.actionName}>
                                            {r.ActionName}
                                            {!!r.GitResourceReferenceName && <span>/{r.GitResourceReferenceName}</span>}
                                        </div>
                                        <span>{r.RepositoryUri}</span>
                                    </LegacyDataTableRowColumn>
                                    {showFilePaths && (<LegacyDataTableRowColumn key={`rowForLast${ix}`} className={cn(styles.pathsColumn)}>
                                            <FilesList filePaths={r.FilePathFilters} actionName={r.ActionName}/>
                                        </LegacyDataTableRowColumn>)}
                                    <LegacyDataTableRowColumn key={`rowForGitReference${ix}`} className={cn(styles.packageTableRowColumn, styles.specificColumn)}>
                                        {r.GitResource !== null && <GitRefLink key={`${r.GitResource.GitRef} ${r.GitResource.GitCommit} ${ix}`} gitRef={r.GitResource} commitUrl={getCommitLink(r.RepositoryUri, r.GitResource.GitCommit)}/>}
                                    </LegacyDataTableRowColumn>
                                </LegacyDataTableRow>))}
                        </LegacyDataTableBody>
                    </LegacyDataTable>) : (<Section>
                        <Note>There are no Git resource references associated with any steps.</Note>
                    </Section>)}
            </div>));
    }
    static displayName = "GitResourcesList";
}
